import Joi from '@hapi/joi'

export const QRTagGenerationWithFactorySchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    routeID: Joi.number().invalid(0).required().label("Route").messages({
        "any.invalid": `Select Route`,
        "any.required": `Route required`
    }),
    noOfCodes: Joi.number().required().invalid(0).min(1).max(100).label("No. of Codes").messages({
        "any.invalid": `Select Number of codes`,
        "any.required": `Number of codes required`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`
    }),


    
}

